import { FC, useEffect } from "react";
import styles from "./ModalImages.module.scss";
import classNames from "classnames";
import "./Swiper.scss";

import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
import { Modal } from "../../common/Modal";
import { LayziImage } from "../../common/LazyImage";
import { SwiperOptions } from "swiper/types/swiper-options";

const options: SwiperOptions = {
  modules: [Pagination, Navigation],
  direction: "horizontal",
  loop: false,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
};

interface ModalImagesProps {
  classess?: string;
  images: { img: string; webp: string }[];
  activeIndex: number;
  isOpen: boolean;
  onClose: () => void;
  setIndex: (index: number) => void;
}

const ModalImages: FC<ModalImagesProps> = ({
  classess,
  images,
  activeIndex,
  isOpen,
  onClose,
  setIndex,
}) => {
  const swiper = new Swiper(".swiper", options);

  useEffect(() => {
    if (isOpen) {
      try {
        if (swiper && !swiper.destroyed) {
          swiper.slideTo(activeIndex);
        }
      } catch (error) {
        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex, isOpen]);

  useEffect(() => {
    const onNext = (swiper: Swiper) => {
      setIndex(swiper.activeIndex);
    };

    swiper.on("slideNextTransitionEnd", onNext);

    return () => swiper.off("slideNextTransitionEnd", onNext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      classess={{ content: styles.content }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={classNames(styles.ModalImages, {}, [classess])}>
        <div className="swiper">
          <div className="swiper-wrapper">
            {images.map((img, i) => (
              <div
                onClick={onClose}
                key={i.toString()}
                className="swiper-slide"
              >
                <picture>
                  <source srcSet={img.webp} />
                  <LayziImage
                    onClick={(e) => e.stopPropagation()}
                    dataSrc={img.img}
                    alt="image__license"
                  />
                </picture>
              </div>
            ))}
          </div>

          <div className="swiper-button-prev" />
          <div className="swiper-button-next" />
          <div className="swiper-pagination" />
        </div>
      </div>
    </Modal>
  );
};

export default ModalImages;
